import React from 'react';
import { ExtendedContentContainer } from 'components/ExtendedContent/ExtendedContentContainer';
import WordExample from 'components/WordExample';

export const WordExampleModalComponent = ({ wordExampleResource, defaultWord}) => {
    return <ExtendedContentContainer>
        <WordExample data={wordExampleResource} defaultWord={defaultWord} />
    </ExtendedContentContainer>
};
